import { environment } from "../environments/environment.development";
import { httpService } from "./httpService";
import { ReservationShortlist } from "../models/reservationShortlist.model";
import GenericService from "./genericService";

interface UpdateReservationDto {
    roomId: number;
    priority: number;
    checkIn: Date | string;
    checkOut: Date | string;
    noOfAdults: number;
    noOfChildrens: number;
}

interface UpdatePriorityDto {
    roomId: number;
    priority: number;
}

interface ReservationDto {
    checkIn: Date;
    checkOut: Date;
    roomId: number;
    propertyId?: number;
    noOfAdults: number;
    noOfChildrens: number;
}

export type { UpdateReservationDto, UpdatePriorityDto, ReservationDto };

class ReservationShortlistService extends GenericService<ReservationShortlist> {
    constructor() {
        super('/api/ReservationShortlist');
    }

    async createReservationShortlist(data: ReservationShortlist): Promise<any> {
        // Return the full ApiResponse object (do not unwrap) and disable automatic toasts
        const response = await httpService.post('/api/ReservationShortlist/shortlist', data, {}, {
            unwrap: false,
            toast: false
        });
        return response;
    }

    async getMyShortlistedItems(): Promise<ReservationShortlist[]> {
        const response = await httpService.get<ReservationShortlist[]>(`/api/ReservationShortlist/my-shortlisted`, undefined, {
            unwrap: true,
            normalize: true,
            toast: false,
        });
        return response as ReservationShortlist[];
    }

    async removeFromShortlist(roomId: number): Promise<void> {
        await httpService.delete(`/api/ReservationShortlist/shortlist/${roomId}`, {
            // Add any custom options here if needed
        });
    }

    async createReserveRequest(reservations: UpdateReservationDto[]): Promise<any> {
        const response = await httpService.put(`${environment.baseURL}/api/ReservationShortlist/ReserveRequest`, 
            reservations, 
            {
                // Add any custom options here if needed
            }
        );
        return response as any;
    }

    async reserveRoom(reservationData: ReservationDto): Promise<any> {
        const response = await httpService.post(`${environment.baseURL}/api/ReservationShortlist/ReserveRoom`, 
            reservationData, 
            {
                // Add any custom options here if needed
            }
        );
        return response as any;
    }

    async updatePriority(roomId: number, priority: number): Promise<void> {
        const updateData: UpdatePriorityDto = {
            roomId: roomId,
            priority: priority
        };
        
        await httpService.put(`${environment.baseURL}/api/ReservationShortlist/UpdatePriority`, updateData, {
            // Add any custom options here if needed
        });
    }

    async getMyBookingHistory(): Promise<any[]> {
        const response = await httpService.get<any[]>(`/api/ReservationShortlist/my-booking-history`, undefined, {
            unwrap: true,
            normalize: true,
            toast: false,
        });
        return response as any[];
    }
}

export const reservationShortlistService = new ReservationShortlistService();
